<template>
  <b-container class="p-4">
    <ResetPassword :token="token"></ResetPassword>
  </b-container>
</template>

<script>
import ResetPassword from "@/components/Modals/ResetPassword";

export default {
  name      : "ResetPasswordVue",
  components: {ResetPassword},
  data() {
    return {
      token: this.$route.params.token
    }
  }
}
</script>

<style scoped>

</style>